export default __webpack_public_path__ + "static/sogn-sparebank-a04532ced6de8c1b6f1bb9ca185e4570.png";